import { createSelector } from '@reduxjs/toolkit'
import { routerSelector } from '@store/selector'
import { RootState } from '@store/store'
import { prop } from 'ramda'

import * as ActionTypes from '../constants/actionTypes'

export const stcGlobalSelector = (state: RootState) => prop(ActionTypes.GLOBAL_STATE, state)

export const stcSelector = createSelector(
  stcGlobalSelector,
  (state: ReturnType<typeof stcGlobalSelector>) => state[ActionTypes.STC]
)

export const currentChapterSelector = createSelector(
  (state: RootState) => state,
  stcSelector,
  (state: RootState) => routerSelector(state).query['chapter'],
  (_, stc, chapterId) => {
    if (stc['data'] && chapterId) {
      return stc['data'].chapters.find(item => item.id === Number(chapterId))
    }
    return null
  }
)

export const currentTopicSelector = createSelector(
  (state: RootState) => state,
  currentChapterSelector,
  (state: RootState) => routerSelector(state).query['topic'],
  (_, chapter, topicId) => {
    if (topicId && chapter) {
      return chapter.topics.find(item => item.id === Number(topicId))
    }
    return null
  }
)

export const currentStepSelector = createSelector(
  (state: RootState) => state,
  currentTopicSelector,
  (state: RootState) => routerSelector(state).query['step'],
  (_, topic, stepId) => {
    if (topic && topic) {
      return topic.steps.find(item => item.id === Number(stepId))
    }
    return null
  }
)

export const stcCreateSelector = createSelector(
  stcGlobalSelector,
  (state: ReturnType<typeof stcGlobalSelector>) => state[ActionTypes.STC_CREATE]
)
export const stcAllSelector = createSelector(
  stcGlobalSelector,
  (state: ReturnType<typeof stcGlobalSelector>) => state[ActionTypes.STC_ALL]
)
export const stcListSelector = createSelector(
  stcGlobalSelector,
  (state: ReturnType<typeof stcGlobalSelector>) => state[ActionTypes.STC_LIST]
)
export const stcCategorySelector = createSelector(
  stcGlobalSelector,
  (state: ReturnType<typeof stcGlobalSelector>) => state[ActionTypes.STC_CATEGORY]
)
export const stcCategoryAllSelector = createSelector(
  stcGlobalSelector,
  (state: ReturnType<typeof stcGlobalSelector>) => state[ActionTypes.STC_CATEGORY_ALL]
)
export const stcCategoryAllOptionsSelector = createSelector(stcCategoryAllSelector, selected => {
  return {
    loading: selected.loading,
    error: selected.error,
    options: Array.isArray(selected.data)
      ? selected.data.map(item => ({
          label: item.title || '',
          value: item.id,
        }))
      : [],
  }
})

export const stcCategoryCreateSelector = createSelector(
  stcGlobalSelector,
  (state: ReturnType<typeof stcGlobalSelector>) => state[ActionTypes.STC_CATEGORY_CREATE]
)
export const stcCategoryListSelector = createSelector(
  stcGlobalSelector,
  (state: ReturnType<typeof stcGlobalSelector>) => state[ActionTypes.STC_CATEGORY_LIST]
)
export const stcStepSelector = createSelector(
  stcGlobalSelector,
  (state: ReturnType<typeof stcGlobalSelector>) => state[ActionTypes.STC_STEP]
)
export const stcStepAllSelector = createSelector(
  stcGlobalSelector,
  (state: ReturnType<typeof stcGlobalSelector>) => state[ActionTypes.STC_STEP_ALL]
)
export const stcStepListSelector = createSelector(
  stcGlobalSelector,
  (state: ReturnType<typeof stcGlobalSelector>) => state[ActionTypes.STC_STEP_LIST]
)
export const stcStepCreateSelector = createSelector(
  stcGlobalSelector,
  (state: ReturnType<typeof stcGlobalSelector>) => state[ActionTypes.STC_STEP_CREATE]
)
export const stcStepCompleteSelector = createSelector(
  stcGlobalSelector,
  (state: ReturnType<typeof stcGlobalSelector>) => state[ActionTypes.STC_STEP_COMPLETE]
)

export const stcChapterSelector = createSelector(stcGlobalSelector, prop(ActionTypes.STC_CHAPTER))

export const stcChapterAllSelector = createSelector(stcGlobalSelector, prop(ActionTypes.STC_CHAPTER_ALL))

export const stcChapterListSelector = createSelector(stcGlobalSelector, prop(ActionTypes.STC_CHAPTER_LIST))

export const stcTopicSelector = createSelector(stcGlobalSelector, prop(ActionTypes.STC_TOPIC))

export const stcTopicAllSelector = createSelector(stcGlobalSelector, prop(ActionTypes.STC_TOPIC_ALL))

export const stcTopicListSelector = createSelector(stcGlobalSelector, prop(ActionTypes.STC_TOPIC_LIST))

export const stcAdminSelector = createSelector(stcGlobalSelector, data => data[ActionTypes.STC_ADMIN])

export const stcStepAdminAllSelector = createSelector(stcGlobalSelector, prop(ActionTypes.STC_STEP_ADMIN_ALL))
